import { UI } from '@/lib/ui-strings';

export default function SkipLink() {
  return (
    <a className="hp-skip-link" href="#main">
      {UI.skipToContent}
    </a>
  );
}
